var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb10" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              attrs: {
                model: _vm.queryForm,
                size: "small",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.licensePlateNumber"
                            ),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              type: "textarea",
                              rows: 5,
                            },
                            model: {
                              value: _vm.licensePlateNumber,
                              callback: function ($$v) {
                                _vm.licensePlateNumber = $$v
                              },
                              expression: "licensePlateNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("mdfeTranslate.MDFEKey") } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              type: "textarea",
                              rows: 5,
                            },
                            model: {
                              value: _vm.mdfeKeyStr,
                              callback: function ($$v) {
                                _vm.mdfeKeyStr = $$v
                              },
                              expression: "mdfeKeyStr",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 14 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "mdfeTranslate.AgreementNumber"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "GlobalSetObj.pleaseInput"
                                      ),
                                      clearable: "",
                                    },
                                    model: {
                                      value:
                                        _vm.queryForm.params.protocolNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "protocolNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.protocolNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "mdfeTranslate.startingPoint"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "formTable",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "placeOrder.pleaseChoose"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value: _vm.queryForm.params.originState,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "originState",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.originState",
                                      },
                                    },
                                    _vm._l(
                                      _vm.senderStateList,
                                      function (list) {
                                        return _c("el-option", {
                                          key: list.stateCode,
                                          attrs: {
                                            label:
                                              list.stateNameZh +
                                              "（" +
                                              list.stateNamePu +
                                              "）",
                                            value: list.stateCode,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("mdfeTranslate.destination"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "formTable",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "placeOrder.pleaseChoose"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.queryForm.params.destinationState,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "destinationState",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.destinationState",
                                      },
                                    },
                                    _vm._l(
                                      _vm.senderStateList,
                                      function (list) {
                                        return _c("el-option", {
                                          key: list.stateCode,
                                          attrs: {
                                            label:
                                              list.stateNameZh +
                                              "（" +
                                              list.stateNamePu +
                                              "）",
                                            value: list.stateCode,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "numberSearch",
                                  attrs: { label: "" },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "label" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseChoose"
                                            ),
                                          },
                                          model: {
                                            value:
                                              _vm.queryForm.params.timeType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryForm.params,
                                                "timeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryForm.params.timeType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "GlobalSetObj.CreationTime"
                                              ),
                                              value: 1,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "GlobalSetObj.ClosingTime"
                                              ),
                                              value: 2,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "newOrder.CancellationTime"
                                              ),
                                              value: 3,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "datetimerange",
                                      "range-separator": "-",
                                      "picker-options": _vm.pickerOptions,
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      "default-time": ["00:00:00", "23:59:59"],
                                      "start-placeholder": _vm.$t(
                                        "GlobalSetObj.startDate"
                                      ),
                                      "end-placeholder": _vm.$t(
                                        "GlobalSetObj.endDate"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.queryForm.params.invoiceIssueTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "invoiceIssueTime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.invoiceIssueTime",
                                    },
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label:
                                      "MDF-e" +
                                      _vm.$t("collectionCenter.stateZT"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { multiple: "" },
                                      model: {
                                        value: _vm.queryForm.params.statusList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "statusList",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.statusList",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        key: "1",
                                        attrs: {
                                          label: _vm.$t(
                                            "mdfeTranslate.Authorized"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "2",
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.cancelled"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "3",
                                        attrs: {
                                          label: _vm.$t("mdfeTranslate.Closed"),
                                          value: 3,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "mdfeTranslate.VehicleOperationMode"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      model: {
                                        value:
                                          _vm.queryForm.params
                                            .vehicleOperationMode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "vehicleOperationMode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.vehicleOperationMode",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        key: "0",
                                        attrs: {
                                          label: _vm.$t("basicData.all"),
                                          value: null,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "1",
                                        attrs: {
                                          label: _vm.$t(
                                            "basicData.SelfOperated"
                                          ),
                                          value: 0,
                                        },
                                      }),
                                      _c("el-option", {
                                        key: "2",
                                        attrs: {
                                          label: _vm.$t("basicData.thirdParty"),
                                          value: 1,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              icon: "el-icon-search",
                              size: "mini",
                            },
                            on: { click: _vm.enterGetSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.Search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-refresh", size: "mini" },
                            on: { click: _vm.resetData },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "mb10" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:mdfe-bulkExport",
                      expression: "'btn:invoiceCenter:mdfe-bulkExport'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.bulkExportMdfe },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("collectionCenter.BulkExport")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:mdfe-addMDFE",
                      expression: "'btn:invoiceCenter:mdfe-addMDFE'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.addMDFE },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("collectionCenter.generate") + "MDFE") +
                      " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:mdfe-ForceClose",
                      expression: "'btn:invoiceCenter:mdfe-ForceClose'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "danger" },
                  on: { click: _vm.forceClose },
                },
                [_vm._v(" " + _vm._s(_vm.$t("mdfeTranslate.ForceClose")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:invoiceCenter:mdfe-AbnormalMdfe",
                      expression: "'btn:invoiceCenter:mdfe-AbnormalMdfe'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.showAbnormalWindow },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("mdfeTranslate.AbnormalMdfe")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                height: _vm.tableHeightRow.height,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    align: item.center,
                    label: item.label,
                    "min-width": item.minWidth,
                    prop: item.prop,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "status"
                              ? _c(
                                  "div",
                                  [
                                    scope.row.status === 1
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "mdfeTranslate.Authorized"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : scope.row.status === 2
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("GlobalSetObj.Canceled")
                                              )
                                            ),
                                          ]
                                        )
                                      : scope.row.status === 3
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("mdfeTranslate.Closed")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : item.prop === "vehiclePlate"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.transportInfo.vehiclePlate,
                                    function (item, ind) {
                                      return _c("div", { key: ind }, [
                                        _vm._v(" " + _vm._s(item) + " "),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : item.prop === "repeatPackage"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.transportInfo.repeatPackage,
                                    function (item, ind) {
                                      return _c("div", { key: ind }, [
                                        _vm._v(" " + _vm._s(item) + " "),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " + _vm._s(scope.row[item.prop]) + " "
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.operate"),
                  align: "center",
                  fixed: "right",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          { attrs: { placement: "bottom", trigger: "click" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "mini",
                                  type: "text",
                                },
                                slot: "reference",
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-more",
                                  staticStyle: { "font-size": "26px" },
                                }),
                              ]
                            ),
                            scope.row.status === 1
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:invoiceCenter:mdfe-lockMDFE",
                                        expression:
                                          "'btn:invoiceCenter:mdfe-lockMDFE'",
                                        arg: "remove",
                                      },
                                    ],
                                    staticStyle: { margin: "5px" },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top-start",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "content" }, [
                                          _c("div", [
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-a-ziyuan106",
                                              staticStyle: {
                                                color: "#1d90ff",
                                                "font-size": "12px!important",
                                                "margin-right": "5px",
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mdfeTranslate.EncerrarMdfeTips"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.closeMDFE(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("mdfeTranslate.LockMDFE")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            scope.row.status === 1
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:invoiceCenter:mdfe-clearMDFE",
                                        expression:
                                          "'btn:invoiceCenter:mdfe-clearMDFE'",
                                        arg: "remove",
                                      },
                                    ],
                                    staticStyle: { margin: "5px" },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          placement: "top-start",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "content" }, [
                                          _c("div", [
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-a-ziyuan40",
                                              staticStyle: {
                                                color: "#bd2c00",
                                                "font-size": "12px!important",
                                                "margin-right": "5px",
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "mdfeTranslate.CancelMdfeTips"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clearMDFE(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "mdfeTranslate.CancelMDFE"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            scope.row.status === 1 || scope.row.status === 3
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:invoiceCenter:mdfe-viewMDFEPDF",
                                        expression:
                                          "'btn:invoiceCenter:mdfe-viewMDFEPDF'",
                                        arg: "remove",
                                      },
                                    ],
                                    staticStyle: { margin: "5px" },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewMDFEPDF(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("mdfeTranslate.ViewPDF")
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            scope.row.status === 1
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "permit",
                                        rawName: "v-permit:remove",
                                        value:
                                          "btn:invoiceCenter:mdfe-downloadCtePDF",
                                        expression:
                                          "'btn:invoiceCenter:mdfe-downloadCtePDF'",
                                        arg: "remove",
                                      },
                                    ],
                                    staticStyle: { margin: "5px" },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadCtePDF(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("mdfeTranslate.BatchCTEPDF")
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value: "btn:invoiceCenter:mdfe-viewDriver",
                                    expression:
                                      "'btn:invoiceCenter:mdfe-viewDriver'",
                                    arg: "remove",
                                  },
                                ],
                                staticStyle: { margin: "5px" },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewDriver(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("mdfeTranslate.ViewDriver"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:invoiceCenter:mdfe-downloadXlsx",
                                    expression:
                                      "'btn:invoiceCenter:mdfe-downloadXlsx'",
                                    arg: "remove",
                                  },
                                ],
                                staticStyle: { margin: "5px" },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadXlsx(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.DownloadXlsx")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value: "btn:invoiceCenter:mdfe-downloadXml",
                                    expression:
                                      "'btn:invoiceCenter:mdfe-downloadXml'",
                                    arg: "remove",
                                  },
                                ],
                                staticStyle: { margin: "5px" },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadXml(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mdfeTranslate.DownloadXml")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { margin: "5px" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openOperationalLogs(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "operationCenter.OperationalLogs"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.queryForm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("addMdfe", {
        attrs: {
          "show-add-m-d-f-e-window": _vm.showAddMDFEWindow,
          "sender-state-list": _vm.senderStateList,
        },
        on: { closeWindow: _vm.updateData },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.ViewDriver"),
            visible: _vm.showViewDriverWindow,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showViewDriverWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            _vm._l(_vm.driverInformation, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticStyle: {
                    border: "1px solid #ccc",
                    "border-radius": "5px",
                    padding: "10px",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c("div", [
                    _c("i", {
                      staticClass: "el-icon-user",
                      staticStyle: { "margin-right": "3px" },
                    }),
                    _c(
                      "span",
                      { staticStyle: { color: "#000", "font-weight": "bold" } },
                      [_vm._v(_vm._s(_vm.$t("ChannelManage.name")) + "：")]
                    ),
                    _vm._v(" " + _vm._s(item.name) + " "),
                  ]),
                  _c("div", [
                    _c("i", {
                      staticClass: "iconfont icon-liebiao",
                      staticStyle: { "margin-right": "3px" },
                    }),
                    _c(
                      "span",
                      { staticStyle: { color: "#000", "font-weight": "bold" } },
                      [_vm._v("CPF：")]
                    ),
                    _vm._v(" " + _vm._s(item.cpf) + " "),
                  ]),
                ]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showViewDriverWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.ViewPDF"),
            visible: _vm.showViewPDFWindow,
            width: "90%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showViewPDFWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _vm.showViewPDFWindow
                ? _c("pdfHtml", {
                    key: _vm.viewPDFWindowKey,
                    attrs: {
                      "row-m-d-f-e-data": _vm.rowMDFEData,
                      "cte-data": _vm.cteData,
                      "pdf-data": _vm.pdfData,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showViewPDFWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.DownloadXlsx"),
            visible: _vm.showDownloadXlsx,
            width: "80%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDownloadXlsx = $event
            },
          },
        },
        [
          _vm.showDownloadXlsx
            ? _c(
                "div",
                [
                  _c("downloadXlsx", {
                    key: _vm.downloadXlsxKey,
                    ref: "downloadXlsxRef",
                    attrs: {
                      "cte-data": _vm.cteData,
                      "row-m-d-f-e-data": _vm.rowMDFEData,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmDownloadXlsx },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Download")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showDownloadXlsx = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.DownloadXml"),
            visible: _vm.showDownloadXML,
            width: "90%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDownloadXML = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "border-radius": "5px",
                border: "1px solid #ccc",
                padding: "10px",
                width: "100%",
                height: "500px",
                overflow: "auto",
              },
            },
            [_c("pre", [_vm._v(_vm._s(_vm.rowMDFEData.xmlString))])]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmDownloadXML },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Download")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showDownloadXML = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.BatchCTEPDF"),
            visible: _vm.showDownloadCtePDF,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDownloadCtePDF = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "border-radius": "5px" } }, [
            _c(
              "div",
              {
                ref: "virtualContainer",
                staticClass: "virtual-scroll-container-pdf",
                on: { scroll: _vm.handleScrollPDF },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "virtual-scroll-placeholder-pdf",
                    style: { height: _vm.totalHeightPDF + "px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "virtual-scroll-content-pdf",
                        style: {
                          transform: "translateY(" + _vm.offsetYPDF + "px)",
                        },
                      },
                      _vm._l(_vm.visibleItemsPDF, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              padding: "3px 10px",
                              border: "1px solid #ddd",
                              "border-radius": "3px",
                              margin: "5px",
                            },
                          },
                          [_vm._v(" " + _vm._s(item.invoiceKey) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.cteData.length === 0,
                  },
                  on: { click: _vm.confirmDownloadCtePDF },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Download")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showDownloadCtePDF = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.BatchCTEPDF"),
            visible: _vm.showDownloadCteXML,
            width: "90%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDownloadCteXML = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("ctePDF", {
                key: _vm.downloadCteXMLKey,
                attrs: {
                  "row-m-d-f-e-data": _vm.rowMDFEData,
                  "cte-data": _vm.cteData,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showDownloadCteXML = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.ForceClose"),
            visible: _vm.showForceCloseWindow,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showForceCloseWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("forceClose", {
                key: _vm.forceCloseKey,
                ref: "forceCloseRef",
                on: { forceCloseSuccess: _vm.forceCloseSuccess },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.confirmForceClose },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showForceCloseWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.$t("operationCenter.OperationalLogs"),
            visible: _vm.showOperationalLogs,
            direction: "rtl",
            size: "80vw",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showOperationalLogs = $event
            },
          },
        },
        [
          _c("operational-log", {
            key: _vm.operationalLogKey,
            attrs: { "log-key": _vm.logKey },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.AbnormalMdfeProcessing"),
            visible: _vm.showAbnormalMdfe,
            width: "80%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAbnormalMdfe = $event
            },
          },
        },
        [
          _c("abnormalMdfe", {
            key: _vm.abnormalKey,
            on: { updateTable: _vm.updateTable },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCloseMdfeWindow,
            width: "700px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "3%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCloseMdfeWindow = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "closeTitle" }, [
              _c("i", { staticClass: "el-icon-question" }),
              _c("span", { staticClass: "titleCont" }, [
                _vm._v(_vm._s(_vm.$t("mdfeTranslate.CloseMDFeEndTheTrip"))),
              ]),
            ]),
          ]),
          _c("div", [_c("close-mdfe-tips")], 1),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCloseMdfeWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("mdfeTranslate.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-check" },
                  on: { click: _vm.confirmCloseMDFe },
                },
                [_vm._v(" " + _vm._s(_vm.$t("mdfeTranslate.Confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCancelMdfeWindow,
            width: "700px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "3%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCancelMdfeWindow = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "closeTitle" }, [
              _c("i", { staticClass: "el-icon-warning" }),
              _c("span", { staticClass: "titleCont" }, [
                _vm._v(_vm._s(_vm.$t("mdfeTranslate.CancelMDFe"))),
              ]),
            ]),
          ]),
          _c(
            "div",
            [
              _c("cancel-mdfe-tips", {
                key: _vm.showCancelMdfeWindow,
                ref: "cancelMdfeDataRef",
                attrs: { "row-m-d-f-e-data": _vm.rowMDFEData },
                on: { cancelMdfeSuccess: _vm.cancelMdfeSuccess },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCancelMdfeWindow = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("mdfeTranslate.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { background: "#d52526", border: "0" },
                  attrs: { type: "primary", icon: "el-icon-close" },
                  on: { click: _vm.confirmCancelMDFe },
                },
                [_vm._v(" " + _vm._s(_vm.$t("mdfeTranslate.Confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }